// liga o "pace.js", para mostrar visualmente o progresso de operações Ajax
import pace from 'pace';
import 'pace/themes/blue/pace-theme-flash.css';

pace.start();
